import PopupContainerComponent from '../components/PopupContainer/viewer/PopupContainer';
import PopupContainerController from '../components/PopupContainer/viewer/PopupContainer.controller';
import PopupPageComponent from '../components/PopupPage/viewer/PopupPage';
import ResponsivePopupContainerComponent from '../components/ResponsivePopupContainer/viewer/ResponsivePopupContainer';
import ResponsivePopupContainerController from '../components/ResponsivePopupContainer/viewer/ResponsivePopupContainer.controller';
import ResponsivePopupPageComponent from '../components/ResponsivePopupPage/viewer/ResponsivePopupPage';
import ResponsivePopupPageController from '../components/ResponsivePopupPage/viewer/ResponsivePopupPage.controller';
import ResponsivePopupPage_WithoutOverlayComponent from '../components/ResponsivePopupPage/viewer/skinComps/WithoutOverlay/WithoutOverlay.skin';


const PopupContainer = {
  component: PopupContainerComponent,
  controller: PopupContainerController
};

const PopupPage = {
  component: PopupPageComponent
};

const ResponsivePopupContainer = {
  component: ResponsivePopupContainerComponent,
  controller: ResponsivePopupContainerController
};

const ResponsivePopupPage = {
  component: ResponsivePopupPageComponent,
  controller: ResponsivePopupPageController
};

const ResponsivePopupPage_WithoutOverlay = {
  component: ResponsivePopupPage_WithoutOverlayComponent,
  controller: ResponsivePopupPageController
};


export const components = {
  ['PopupContainer']: PopupContainer,
  ['PopupPage']: PopupPage,
  ['ResponsivePopupContainer']: ResponsivePopupContainer,
  ['ResponsivePopupPage']: ResponsivePopupPage,
  ['ResponsivePopupPage_WithoutOverlay']: ResponsivePopupPage_WithoutOverlay
};

